import { AnyAction } from 'redux';
import { SET_THEME } from '../types/types';

const initialState = {
	dark: false
};

export default function themeReducer(state = initialState, action: AnyAction) {
	switch (action.type) {
		case SET_THEME: {
			const className = 'dark';
			const bodyClass = window.document.body.classList;

			!action.dark ? bodyClass.add(className) : bodyClass.remove(className);
			return {
				dark: action.dark
			};
		}
		default:
			return state;
	}
}
